export const caiValues = [
  "Act",
  "Act Navigation",
  "Administration Instrument",
  "Administrative Letter",
  "Administrative Order",
  "Advice",
  "Advisory Letter",
  "Advisory Opinion",
  "Agency Update",
  "Amended Bill",
  "Amendment",
  "Amicus Brief",
  "Announcement",
  "Annual Report",
  "Audit",
  "Bill",
  "Bill Analysis",
  "Blog",
  "Breach Notification Decision",
  "Budget",
  "Bulletin",
  "Business Plan",
  "By-Law",
  "By-Law Navigation",
  "CFR",
  "CFR CAI",
  "CFR Navigation",
  "Cease and Desist",
  "Checklist",
  "Circular",
  "Civil Money Penalty",
  "Code",
  "Code Navigation",
  "Comment",
  "Commissioner's Order",
  "Company Filing",
  "Complaint",
  "Conference",
  "Consent Order",
  "Consultation",
  "Consultation Paper",
  "Consumer Alert",
  "Contract",
  "Control",
  "Control Navigation",
  "Corporate Document",
  "Corporate Report",
  "Correspondence",
  "Court Filing",
  "Decision",
  "Decision (EU)",
  "Decision (EU) Navigation",
  "Decree",
  "Decree Law",
  "Determination",
  "Directive",
  "Directive (EU)",
  "Directive (EU) Navigation",
  "Disciplinary Action",
  "Discussion Paper",
  "Document Type",
  "Emergency Order",
  "Emergency Rule",
  "Enforcement",
  "Enforcement Decision",
  "Enforcement Notice",
  "Enforcement Order",
  "Enforcement Report",
  "Engrossed Bill",
  "Enrolled And Enacted Bill",
  "Enrolled Bill",
  "Event",
  "Examination Manual",
  "Examination Manual Navigation",
  "Executive Order",
  "Executive Order Navigation",
  "Exemptive Letter",
  "Exemptive order",
  "FAQ",
  "Fact Sheet",
  "Feedback Statement",
  "Final Notice",
  "Final Order",
  "Final Report",
  "Finalised Guidance",
  "Financial Institution Letter",
  "Financial Sanction",
  "Form",
  "Guidance",
  "Guidance Navigation",
  "Guidance Notice",
  "Guide",
  "Guide Navigation",
  "Guideline",
  "Guideline Navigation",
  "Handbook",
  "Handbook Navigation",
  "Impact Assessment",
  "Implementation Plan",
  "Industry Filing",
  "Industry Guidance",
  "Industry Letter",
  "Injunction Order",
  "Instruction",
  "International Treaty",
  "Interpretive Letter",
  "Interpretive Statement",
  "Introduced Bill",
  "Investor Alert",
  "Journal",
  "Journal Navigation",
  "Judgement",
  "Law",
  "Law CAI",
  "Law CAI Navigation",
  "Law Navigation",
  "Lawmaking",
  "Legislative Debate",
  "Letter",
  "Letters to Credit Unions",
  "Mainstream News",
  "Manual",
  "Manual Navigation",
  "Market Conduct Examination Report",
  "Meeting Minutes",
  "Memorandum",
  "Memorandum of Understanding",
  "Model Law Navigation",
  "Mortgagee Letter",
  "Motion",
  "Multilateral Instrument",
  "National Instrument",
  "News",
  "News Release",
  "Newsletter",
  "No Action Letter",
  "Notice",
  "Opinion",
  "Opinion Letter",
  "Order",
  "Ordinance",
  "Ordinance Navigation",
  "Petition",
  "Policy Navigation",
  "Policy Paper",
  "Policy Statement",
  "Policy Statement Navigation",
  "Position Paper",
  "Press Release",
  "Proclamation",
  "Prohibition Order",
  "Proposed Rule",
  "Prudential Regulation",
  "Public Law",
  "Publication",
  "Publications",
  "Rate Filing",
  "Recommendation",
  "Regulation (EU)",
  "Regulation (EU) Navigation",
  "Regulatory Agenda",
  "Regulatory Alert",
  "Regulatory Decision",
  "Regulatory Digest",
  "Regulatory Filing",
  "Regulatory Order",
  "Regulatory Order Navigation",
  "Report",
  "Research Publication",
  "Resolution",
  "Response",
  "Revocation Order",
  "Risk Alert",
  "Rule",
  "Rule Certification",
  "Rule Navigation",
  "Rulemaking",
  "Ruling",
  "SR Letter",
  "Servicing Guide",
  "Servicing Guide Navigation",
  "Settlement Agreement",
  "Speech",
  "Standard",
  "Standard Navigation",
  "State Code",
  "State Code Navigation",
  "State Register",
  "Statement",
  "Statement of Policy",
  "Statistical Data Set",
  "Statistics",
  "Statute",
  "Statute Navigation",
  "Supervisory Guidance",
  "Supervisory Letter",
  "Supervisory Report",
  "Supervisory Statement",
  "Supporting Document",
  "Suspension Order",
  "Tariff",
  "Tax Rate",
  "Termination Order",
  "Testimony",
  "Transcript",
  "US Code",
  "US Code Navigation",
  "US Public Law",
  "US Public Law Navigation",
  "Warning Notice",
  "Whitepaper",
  "Working Paper"
];
